module.exports = __webpack_public_path__ + "static/2-d49dee85285e25794b30d6d99e58568b.jpg";